(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@material/menu-surface", [], factory);
	else if(typeof exports === 'object')
		exports["menu-surface"] = factory();
	else
		root["mdc"] = root["mdc"] || {}, root["mdc"]["menu-surface"] = factory();
})(this, function() {
return 